import { api } from "../utils/api";
import type {
  RestCreateProductPageType,
  RestProductPage,
  RestUpdateProductPageType,
} from "@KassaroAB/shared/types/productPage";
import type { ProductPageId } from "@KassaroAB/shared/types/ids";
import {
  catalogCollectionPath,
  type CatalogScope,
} from "./catalogScope";

const productPagesPath = (scope: CatalogScope) =>
  catalogCollectionPath(scope, "productPages");

export const getProductPagesApi = (
  scope: CatalogScope,
): Promise<RestProductPage[]> => {
  return api.get(productPagesPath(scope));
};

export const getProductPageApi = (
  scope: CatalogScope,
  productPageId: ProductPageId,
): Promise<RestProductPage> => {
  return api.get(`${productPagesPath(scope)}/${productPageId}`);
};

export const createProductPageApi = (
  scope: CatalogScope,
  productPage: RestCreateProductPageType,
): Promise<RestProductPage> => {
  return api.post(productPagesPath(scope), productPage);
};

export const updateProductPageApi = (
  scope: CatalogScope,
  productPageId: ProductPageId,
  productPage: RestUpdateProductPageType,
): Promise<RestProductPage> => {
  return api.put(`${productPagesPath(scope)}/${productPageId}`, productPage);
};

export const deleteProductPageApi = (
  scope: CatalogScope,
  productPageId: ProductPageId,
): Promise<void> => {
  return api.delete(`${productPagesPath(scope)}/${productPageId}`);
};
